import api from "./api";

// Cache partagé du contenu CMS (/homepage) : évite le "flash" des valeurs par
// défaut à chaque navigation en hydratant immédiatement avec le dernier contenu connu.
let _cache = null;
let _at = 0;
let _inflight = null;
try { _cache = JSON.parse(localStorage.getItem("cs_homepage")) || null; } catch (e) { _cache = null; }

export const getHomepageCache = () => _cache || {};

// Une seule requête partagée par tous les composants qui montent en même temps.
export const fetchHomepage = () => {
  if (_inflight) return _inflight;
  if (_at && Date.now() - _at < 5000) return Promise.resolve(_cache);
  _inflight = api.get("/homepage").then((r) => {
    _cache = r.data || {};
    _at = Date.now();
    try { localStorage.setItem("cs_homepage", JSON.stringify(_cache)); } catch (e) {}
    return _cache;
  }).finally(() => { _inflight = null; });
  return _inflight;
};
